export default "__VITE_ASSET__vqEfsPfW__"